import React from 'react';
import { Accordion } from '../../ui/Accordion';
import { Button } from '../../ui/Button';
export const AIFAQ = () => {
  const faqItems = [{
    title: 'What does a Fractional Head of AI actually do?',
    content: <p data-id="element-157">
          They own your AI strategy end-to-end — identifying opportunities,
          prioritizing use cases, selecting tools and models, shipping POCs and
          production features, and enabling your existing team. Think of it as a
          senior AI executive on your team, part-time.
        </p>
  }, {
    title: 'Is this a good fit if we have no AI in production yet?',
    content: <p data-id="element-158">
          Yes. Many of our engagements begin with an AI audit and opportunity
          assessment. Your fractional lead will help you identify the right
          first bets, design POCs, and build the foundational capabilities
          needed to ship AI responsibly.
        </p>
  }, {
    title: 'How is this different from hiring an AI consultant?',
    content: <p data-id="element-159">
          Consultants advise. Our fractional leaders embed, own outcomes, and
          ship. They join your Slack, attend your standups, hire with you, and
          are accountable for results — just like a full-time Head of AI, at a
          fraction of the cost.
        </p>
  }, {
    title: 'Do you handle model selection and infrastructure decisions?',
    content: <p data-id="element-160">
          Yes. Our leaders have deep experience across the model landscape
          (OpenAI, Anthropic, open-source), evaluation frameworks, RAG
          architectures, fine-tuning, and production infrastructure. We help you
          make informed build-vs-buy decisions.
        </p>
  }, {
    title: 'Can you help with AI governance, safety, and compliance?',
    content: <p data-id="element-161">
          Absolutely. We help establish responsible AI policies, evaluation
          guardrails, and compliance frameworks appropriate to your industry —
          especially for teams in regulated spaces like healthcare, fintech, and
          enterprise SaaS.
        </p>
  }, {
    title: 'How quickly can we start?',
    content: <p data-id="element-162">
          Within 48 hours of your initial consult. We match you with a
          fractional Head of AI whose background aligns with your stage and
          industry, and they begin work immediately — no lengthy hiring or
          procurement processes.
        </p>
  }, {
    title: 'What if we want to eventually hire a full-time Head of AI?',
    content: <p data-id="element-163">
          We actively support that transition. Your fractional lead can help you
          scope the role, screen candidates, and ensure a smooth handoff. Many
          clients work with us for 6–12 months while they search for and onboard
          a full-time hire.
        </p>
  }, {
    title: "What if we're not satisfied?",
    content: <p data-id="element-164">
          If the fit isn't right, we'll swap your AI lead. If you decide this
          service isn't for you within the first 14 days, we'll refund 75% of
          your payment.
        </p>
  }];
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  return <section id="ai-faq" className="py-20 bg-purple-50 relative overflow-hidden" data-id="element-165">
      <div className="absolute top-0 left-0 w-96 h-96 bg-purple-100 rounded-full opacity-40 -ml-48 -mt-48" data-id="element-166"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-purple-100 rounded-full opacity-30 -mr-40 -mb-40" data-id="element-167"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-168">
        <div className="text-center mb-16" data-id="element-169">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-black" data-id="element-170">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto" data-id="element-171">
            Everything you need to know about our Fractional Head of AI service.
          </p>
        </div>
        <div className="max-w-3xl mx-auto bg-white p-6 rounded-lg border border-gray-100 shadow-card" data-id="element-172">
          <Accordion items={faqItems} data-id="element-173" />
        </div>
        <div className="mt-16 text-center" data-id="element-174">
          <Button variant="primary" onClick={openCalendly} className="text-lg px-8 py-4" data-id="element-175">
            Speak with an AI Lead
          </Button>
        </div>
      </div>
    </section>;
};